export const CustomerMonitoringQueuePage = () => {
  return <>Tela Queue</>;
};

export default CustomerMonitoringQueuePage;
